export default __webpack_public_path__ + "static/media/backArrow.acc7cd27.svg";